module.exports = __webpack_public_path__ + "static/media/unid.e0a0ce40.svg";